import React from 'react';

import classes from '../installPics.css';

import CorrugatedImg1 from '../../../../../../../assets/CorrugatedImg1.JPG';

const CorrugatedPic1
 = () => (
     <div className={classes.installImages}>
         <img alt="22kW residential installation in New Jersey" src={CorrugatedImg1} className={classes.installImg} />
     </div>
 );


export default CorrugatedPic1;



// WEBPACK FOOTER //
// ./src/containers/Simulator/TabBar/Results/SalesLogic/InstallImages/CorrugatedMetal/CorrugatedImg1.js